import clsx from 'clsx';
import React from 'react';
import './UiIconMaterial.css';
export function UiIconMaterial(_a) {
    var size = _a.size, className = _a.className, children = _a.children;
    return React.createElement("i", { className: clsx('UiIconMaterial', 'material-icons', className, size && "size-" + size) }, children);
}
